'use client'

import PropTypes from 'prop-types'
import { LargeNotesIcon } from '@repo/ui/LargeNotesIcon'
import { useWizardStore } from '@repo/store/useWizardStore'
import { WizardFooter } from '@repo/ui/WizardFooter'
import { WizardIconTitle } from '@repo/ui/WizardIconTitle'
import { WizardPanel } from '@repo/ui/WizardPanel'
import MUITypography from '@mui/material/Typography'

// Final step. Form submission will be wired up here in a later task; for now it
// just marks the wizard complete so the data held in state can be picked up.
export const ThirdPartyFormConfirmation = ({ updateStepState, wideMode, handlePrevNext }) => {
  const { setWizardIsComplete } = useWizardStore()

  const handleClickContinue = () => {
    updateStepState({ status: 'completed' })
    setWizardIsComplete(true)
  }

  return (
    <>
      <WizardPanel data-testid="ThirdPartyFormConfirmation">
        <WizardIconTitle
          title="Confirmation"
          text="This step is coming soon."
          icon={LargeNotesIcon}
          sx={{ width: '100%' }}
        />
        <MUITypography variant="body1" sx={{ mt: 2 }}>
          Confirm and create the third-party form here.
        </MUITypography>
      </WizardPanel>

      <WizardFooter
        wideMode={wideMode}
        handleClickContinue={handleClickContinue}
        handleClickBack={() => handlePrevNext(-1)}
        continueButtonText="Create form"
      />
    </>
  )
}

ThirdPartyFormConfirmation.propTypes = {
  updateStepState: PropTypes.func,
  wideMode: PropTypes.bool,
  handlePrevNext: PropTypes.func
}
